import BaseService from './base.service';

export default class PartnerService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getPartnerHome = query => {
        return this.get('/partner/partner-home', query);
    };
}
